"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserStorage = void 0;
const localforage_1 = __importDefault(require("localforage"));
const storage_strategy_1 = require("./storage-strategy");
class BrowserStorage {
    constructor(storeName) {
        this.store = localforage_1.default.createInstance({
            driver: [localforage_1.default.INDEXEDDB, localforage_1.default.LOCALSTORAGE],
            name: 'sgme_logger',
            storeName,
        });
    }
    async add(logEvent) {
        const key = (0, storage_strategy_1.createKey)();
        try {
            await this.store.setItem(key, logEvent);
            return key;
        }
        catch (err) {
            console.error('@SGME-Logger Failed to serialize event to browser storage. Retrying...', key, err);
        }
        // If failed, try to add again but without the data
        try {
            const logEventWithoutData = Object.assign(Object.assign({}, logEvent), { parameters: ['Could not serialize data'] });
            await this.store.setItem(key, logEventWithoutData);
            return key;
        }
        catch (err) {
            console.error('@SGME-Logger Could not serialize event to browser storage', key, err);
        }
        return undefined;
    }
    batchGet(batchSize) {
        return new Promise((resolve, reject) => {
            const values = [];
            const keys = [];
            this.store
                .iterate((value, key, iterationNumber) => {
                if (iterationNumber > batchSize) {
                    return;
                }
                values.push(value);
                keys.push(key);
            })
                .then(() => resolve({ values, keys }))
                .catch(reject);
        });
    }
    async batchRemove(keys) {
        await Promise.all(keys.map((key) => this.store.removeItem(key)));
    }
}
exports.BrowserStorage = BrowserStorage;
//# sourceMappingURL=browser-storage.js.map